import React, { useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Footer({ theme }) {
  const [showMenu, setShowMenu] = useState(false);
  const [showNotif, setShowNotif] = useState(false);
  const wrapperRef = useRef(null);

  const handleMouseEnter = () => setShowMenu(true);
  const handleMouseLeave = (e) => {
    if (wrapperRef.current && e.relatedTarget instanceof Node && !wrapperRef.current.contains(e.relatedTarget)) {
      setShowMenu(false);
    }
  };

  // Theme fallback
  const safeTheme = theme || {
    colors: {
      background: "#fff",
      text: "#222",
      logoBackground: "#eee",
      logoText: "#222",
    },
    fontFamily: "inherit",
  };

  // Email click handler
  function handleEmailClick(e) {
    window.location.href = "mailto:zaidxkhan21@gmail.com";
    setShowNotif(true);
    // Pop up stays until X is clicked
  }
  
  

  return (
    <>
      {/* Notification Bar */}
      <AnimatePresence>
  {showNotif && (
    <motion.div
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -80, opacity: 0 }}
      transition={{ type: "spring", stiffness: 400, damping: 32 }}
      className="fixed top-0 left-0 w-full z-50 flex justify-center"
    >
      <div
  className="relative mt-16 px-6 py-3 rounded-xl shadow text-base font-semibold flex items-center justify-center"
  style={{
    background: safeTheme.colors.background,
    color: safeTheme.colors.text,
    fontFamily: safeTheme.fontFamily,
    border: `1.5px solid ${safeTheme.colors.text}`,
    minWidth: 320,
  }}
>
  {/* Centered text */}
  <div className="w-full text-center">
    Email: zaidxkhan21@gmail.com
  </div>

  {/* X button absolutely positioned at right */}
  <button
    className="absolute right-4 top-1/2 -translate-y-1/2 text-lg font-bold hover:opacity-70"
    style={{
      color: safeTheme.colors.text,
      background: "transparent",
      border: "none",
      cursor: "pointer",
    }}
    onClick={() => setShowNotif(false)}
    aria-label="Close notification"
  >
    ×
  </button>
</div>

    </motion.div>
  )}
</AnimatePresence>


      {/* Footer */}
      <div className="flex justify-center items-center gap-4 text-gray-500 py-4 text-sm border-t border-gray-700">
        <div
          ref={wrapperRef}
          className="relative inline-block"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <a
            href="mailto:zaidxkhan21@gmail.com"
            className="cursor-pointer hover:underline px-3 py-1"
            onClick={handleEmailClick}
            style={{
              color: safeTheme.colors.text,
              fontFamily: safeTheme.fontFamily,
            }}
          >
            contact
          </a>
          <AnimatePresence>
            {showMenu && (
              <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 24 }}
                transition={{ type: "spring", stiffness: 420, damping: 32, duration: 0.2 }}
                className="absolute bottom-full left-0 -mb-[1px] -ml-2 rounded-xl shadow-md z-10 border"
                style={{
                  background: safeTheme.colors.background,
                  color: safeTheme.colors.text,
                  borderColor: safeTheme.colors.logoBackground,
                  fontFamily: safeTheme.fontFamily,
                  minWidth: 90,
                }}
              >
                <ul className="py-2">
                  <li>
                  <a
                    href="mailto:zaidxkhan21@gmail.com"
                    className="block px-4 py-2 rounded hover:underline"
                    style={{
                      color: safeTheme.colors.text,
                      fontFamily: safeTheme.fontFamily,
                      background: "transparent",
                    }}
                    onClick={handleEmailClick}
                    onMouseOver={e => {
                      e.currentTarget.style.background = safeTheme.colors.logoBackground;
                      e.currentTarget.style.color = safeTheme.colors.logoText;
                    }}
                    onMouseOut={e => {
                      e.currentTarget.style.background = "transparent";
                      e.currentTarget.style.color = safeTheme.colors.text;
                    }}
                  >
                    Email
                  </a>

                  </li>
                  <li>
                  <a
                href="https://www.linkedin.com/in/zaidxk"
                className="block px-4 py-2 rounded hover:underline"
                style={{
                  color: safeTheme.colors.text,
                  fontFamily: safeTheme.fontFamily,
                  background: "transparent",
                }}
                target="_blank"
                rel="noopener noreferrer"
                onMouseOver={e => {
                  e.currentTarget.style.background = safeTheme.colors.logoBackground;
                  e.currentTarget.style.color = safeTheme.colors.logoText;
                }}
                onMouseOut={e => {
                  e.currentTarget.style.background = "transparent";
                  e.currentTarget.style.color = safeTheme.colors.text;
                }}
              >
                LinkedIn
              </a>

                  </li>
                </ul>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        <a href="#" className="hover:underline">
          support
        </a>
      </div>
    </>
  );
}
